// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CodeExamplesController from "./code_examples_controller"
application.register("code-examples", CodeExamplesController)

import ConsultoriaAutosaveController from "./consultoria_autosave_controller"
application.register("consultoria-autosave", ConsultoriaAutosaveController)

import DynamicFieldsController from "./dynamic_fields_controller"
application.register("dynamic-fields", DynamicFieldsController)

import FlashDismissController from "./flash_dismiss_controller"
application.register("flash-dismiss", FlashDismissController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ParticipationController from "./participation_controller"
application.register("participation", ParticipationController)

import PdfGenerationController from "./pdf_generation_controller"
application.register("pdf-generation", PdfGenerationController)
import PdfGenerationStatusController from "./pdf_generation_status_controller"
application.register("pdf-generation-status", PdfGenerationStatusController)
import DismissibleMessageController from "./dismissible_message_controller"
application.register("dismissible-message", DismissibleMessageController)

import RegistrationPatternController from "./registration_pattern_controller"
application.register("registration-pattern", RegistrationPatternController)

import S3ImageUploadController from "./s3_image_upload_controller"
application.register("s3-image-upload", S3ImageUploadController)

import SitemapController from "./sitemap_controller"
application.register("sitemap", SitemapController)

import TemplateController from "./template_controller"
application.register("template", TemplateController)

import TemplateFormController from "./template_form_controller"
application.register("template-form", TemplateFormController)
